// extracted by mini-css-extract-plugin
export default {"imageWrapper":"zE-z","hovered":"AE-z","hoverImage":"BE-z","mainImage":"CE-z","imageNoBackground":"DE-z","fullSizeImage":"EE-z"};